export const introduction =
  'Prislistor och broschyrer är i pdf-format och öppnas i ett nytt fönster.'

export const priceLists = {
  header: 'Prislistor',
  listItems: [
    {
      label: 'Virke, Fanér & Plywood',
      src: '/prislista_plywood.pdf',
    },
    {
      label: 'Teak inredning',
      src: '/prislista_teak.pdf',
    },
    {
      label: 'Mahogny inredning',
      src: '/prislista_mahogny.pdf',
    },
    {
      label: 'Flaggor och flaggstänger',
      src: '/prislista_flaggor.pdf',
    },
    {
      label: 'Rostfritt',
      src: '/prislista_rostfritt.pdf',
    },
  ],
}

export const brochures = {
  header: 'Broschyrer',
  listItems: [
    {
      label: 'Badplattformar & badstegar (med priser)',
      src: '/broschyr_plattform.pdf',
    },
  ],
}
